/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 分片上传文件
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oss/multipart`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
